const Form005EN = {
    stepName: {
        basicInformation: "Basic Information",
        activitiesInformation: "Information on Activities in the Project",
        effectiveness: "Project Effectiveness and Comments",
        incomeExpenditure: "Statement of Activity Income & Expenditure",
        cost: "Statement of Administration & Project Coordination Cost",
        confirmation: "Confirmation",
    },
    notes: {
        tips1: "1. All information of the e-Form contained herein shall be subject to the application form on the EDB website",
        tipsUrl:
            "https://www.edb.gov.hk/en/student-parents/support-subsidies/after-sch-learning-support-program/community-based-projects/index.html",
        //tips2: "2. School-based After-school Learning and Support Programmes Community-based Projects – Progress Report (up to 31 December of the school year) (This form, duly completed and signed, should be returned to the Student Special Support Section of EDB on or before 31 January of the school year)",
        tips2: "2. School-based After-school Learning and Support Programmes {{schoolyear}}s.y. Community-based Projects–Progress Report ({{upToDateEn}}) (The report should be completed and submitted to the Student Special Support Section of EDB on or before {{deadLineEn}} via e-form (",
        tips2b: "). Alternatively, NGO can also submit the completed and signed report to EDB by mail or by fax.)",
        tipsUrl2: "https://eformss.edb.gov.hk/eformss/Login",
        remarks: {
            tips1: "Eligible students: students in receipt of CSSA, full grant under the SFAS Schemes or needy students under the discretionary quota (only applicable to the students identified by the collaborating school(s))",
            tips2: "Non-eligible students: students who have to pay fees to join an activity. These students <u>must pay full fee</u>; full fee means the <span><b>actual</b> cost</span> of an activity for each participating student (including eligible and non-eligible students) (e.g. if the actual cost for the activity is $1,000 with a total of 6 eligible students and 4 non-eligible students participating in the activity, the cost for each participating student should be $100; each non-eligible student should therefore pay $100)",
            tips3: "Is the activity on schedule? The activity should be stated as: <b>(a) completed; (b) in progress; (c) not yet commenced</b> or <b>(d) cancelled</b>",
            tips4: "Amount of grant: The amount allocated for the activity under the approved project, which <u>should be used to subsidise only the eligible students,</u> while non-eligible students must pay full fee.",
            tips5: `Other income: other sources of revenue such as the fee paid by the non-eligible students, donation and sponsorship. If the figure is not known yet, please fill in "pending"`,
            tips6: `Expenses: the expenses for organising the activity (including subsidy by NGO in the expense). If the figure is not known yet, please fill in "pending"`,
            tips7: "For three types of students:\n- NCS (non-Chinese speaking students)\n- SEN (students with Special Educational Needs)\n- NAC (newly-arrived children)",
            // tips8: `For activities also serving the whole community, <u><b>priority</b></u> should be given to eligible students from "Od" and "Pv" schools\n- Od (students from Government, Aided or Direct Subsidised Scheme schools not listed in (I))\n- Pv (students from private schools)\n- Cs (students from collaborating schools listed in (I))`,
            tips8: `For activities also serving the whole community, <u><b>priority</b></u> should be given to eligible students from "Od" schools\n- Od (students from government, aided and caput schools, schools under the Direct Subsidy Scheme and private schools not listed in (I))\n- Cs (students from collaborating schools listed in (I))`,
        },
    },
    label: {
        statement: "Statement",
        basicInformation: "Basic Information",
        organisationName: "Name of Organisation",
        projectTitle: "Project Title",
        // applicationRefNO: "Application Ref. No.",
        applicationRefNO: "Project ref. no.",
        projectCoordinator: "Project Coordinator",
        contactPerson: "Contact Person",
        contactTelNo: "Contact Tel. No.",
        stepOption: {
            ActivitiesWithSchoolPart1:
                "Activities held with collaborating school(s)",
            ActivitiesOpenCommunityPart1: "Activities open to the community",
        },
        selectContent: "Select the content to be filled in",
        ngoChopFile: "Chop",
        activitiesSchoolTips:
            "Please provide information on all approved activities",
        activitiesInformation: "A. Information on Activities in the Project",
        activitiesSchoolIa:
            "(I) (a) Activities held with collaborating school(s) (List out all the approved activities)",
        activitiesStudentsNo:
            "No. of participating eligible students in approved activities",
        activitiesStudentsNoBefore: "No. of participating eligible students",
        activitiesStudentsNoAfter: " in approved activities",
        totalActivitiesStudentsNo:
            "Total no. of participating eligible students in approved activities",
        activityName: "Name of activity",
        schoolName: "Name of collaborating school(s)",
        actualNo: "Actual no. of students participated",
        remark: "Remark",
        eligibleStudents: "Eligible students",
        nonEligiblestudents: "Non-eligible students",
        secdNoTitle: "No. of Secondary School students",
        remarkEg: "e.g. activity dates: Every Mon,Wed and Fri 4:00–5:30pm",
        priNoTitle: "No. of Primary School students",
        specNoTitle: "No. of Special School students",
        average: "Average attendance rate(%)",
        isSchedule: "Is the activity on schedule",
        financialReport: "Financial report",
        flagOption: {
            0: "No",
            1: "Yes",
        },

        a1: "Amount of grant (HK$) (A1)",
        b1: "Other income (HK$) (B1)",
        c1: "Subsidy from NGO (HK$) (C1)",
        d1: "Expenses (HK$)(D1)",
        a2: "Amount of grant (HK$) (A2)",
        b2: "Other income (HK$) (B2)",
        c2: "Subsidy from NGO (HK$) (C2)",
        d2: "Expenses (HK$) (D2)",
        totalTitle: "Total",
        activitiesTotalNo: "Total no. of activities",
        priTotalNo: "Total no. of Primary School students",
        secdTotalNo: "Total no. of Secondary School students",
        specTotalNo: "Total no. of Special School students",
        manTimesTotal: "Total Man-times (Total no. of students listed above)",
        a1Total: "Total of amount of grant (HK$) (A1)",
        b1Total: "Total of other income (HK$) (B1)",
        c1Total: "Total of subsidy from NGO (HK$) (C1)",
        d1Total: "Total of expenses (HK$) (D1)",
        a2Total: "Total of amount of grant (HK$) (A2)",
        b2Total: "Total of other income (HK$) (B2)",
        c2Total: "Total of subsidy from NGO (HK$) (C2)",
        d2Total: "Total of expenses (HK$) (D2)",
        activitiesSchoolIb: `(I) (b) Information of participating students in collaborating schools (up to {{upToDateEn}})`,
        activitiesSchoolIbi:
            "(i) Comprehensive Social Security Assistance (CSSA)",
        primarySchool: "Primary School",
        studentsNo: "No. of students",
        studentsTitleBefore: "Please provide the no. of students",
        studentsTitleAfter: " per type where applicable",
        NCS: "Non-Chinese speaking students",
        applicableType: "If applicable",
        SEN: "Students with Special Educational Needs",
        NAC: "Newly-arrived children",
        secondarySchool: "Secondary School",
        specialSchool: "Special School",
        activitiesSchoolIbii:
            "(ii) Full grant under the Student Finance Assistance (SFA) Schemes ",
        total: "Total salary",
        activitiesSchoolIbiii:
            "(iii) Total no. of needy students under the discretionary quota (not exceeding 25%) (only applicable to the students identified by the collaborating school(s))",
        activitiesSchoolIbiv:
            "(iv) Total no. of eligible student beneficiaries: (i) + (ii) + (iii) = ",
        activitiesSchoolIbv:
            "(v) Total no. of non-eligible students (must pay full fee)",
        activitiesSchoolIbvBefore: "(v) Total no. of non-eligible",
        activitiesSchoolIbvAfter: " students (must pay full fee)",
        activitiesSchoolIbTotal: "Total no. of students: (iv) + (v) =",
        schoolTypeOption: {
            primarySchool: "Primary School",
            secondarySchool: "Secondary School",
            specialSchool: "Special School",
        },
        activitiesCommunityIIA: "(II) (a) Activities open to the community",
        actualSituationOption: {
            "(a)": "Completed",
            "(b)": "In progress",
            "(c)": "Not yet commenced",
            "(d)": "Cancelled",
        },
        actualSituation: "Is the activity on schedule",
        approvedStudentsNo:
            "No. of participating eligible students in approved activities",
        schoolType: "School type",
        Od: "Od",
        //Pv: "Pv",
        Cs: "Cs",
        odTips: "students from government, aided and caput schools, schools under the Direct Subsidy Scheme and private schools not listed in (I)",
        //pvTips: "students from private schools",
        csTips: "students from collaborating schools listed in (I)",
        primaryOd: "Od(Primary)",
        //primaryPv: "Pv(Primary)",
        primaryCs: "Cs(Primary)",
        secondaryOd: "Od(Secondary)",
        //secondaryPv: "Pv(Secondary)",
        secondaryCs: "Cs(Secondary)",
        specialOd: "Od(Special)",
        //specialPv: "Pv(Special)",
        specialCs: "Cs(Special)",
        averageRate: "Average attendance rate(%)",
        odTotal: "Total no. of Od",
        //pvTotal: "Total no. of Pv",
        csTotal: "Total no. of Cs",
        primaryOdTotal: "Total no. of Od(Primary School)",
        //primaryPvTotal: "Total no. of Pv(Primary)",
        primaryCsTotal: "Total no. of Cs(Primary School)",
        secondaryOdTotal: "Total no. of Od(Secondary School)",
        //secondaryPvTotal: "Total no. of Pv(Secondary)",
        secondaryCsTotal: "Total no. of Cs(Secondary School)",
        specialOdTotal: "Total no. of Od(Special School)",
        //specialPvTotal: "Total no. of Pv(Special)",
        specialCsTotal: "Total no. of Cs(Special School)",
        approvedStudentsNoTotal:
            "Total no. of participating eligible students in approved activities",
        approvedStudentsNoTotalNonEligible:
            "Total no. of participating non-eligible students in approved activities",
        activitiesCommunityIIB: `(II) (b) Information of participating students joining the community activities (up to {{upToDateEn}})`,
        activitiesCommunityIIBvi:
            "(vi) Comprehensive Social Security Assistance (CSSA)",
        primaryHeads: "Primary(Count by heads)",
        secondaryHeads: "Secondary(Count by heads)",
        specialHeads: "Special School(Count by heads)",
        totalHeads: "Total(Count by heads)",
        typeStudentsNo:
            "Provide the no. the following types of students where applicable",
        typeStudentsNoBefore: "Provide the no. the following types of students",
        typeStudentsNoAfter: " where applicable",
        ncs: "NCS",
        sen: "SEN",
        nac: "NAC",
        activitiesCommunityIIBvii:
            "(vii) Full grant under the Student Finance Assistance (SFA) Schemes ",
        activitiesCommunityIIBviii:
            "(viii) Total no. of eligible students benefitted: (vi) + (vii) =",

        totalViii: "Total(Count by heads): (vi)Total + (vii)Total = ",
        totalNcs: "Total(NCS): (vi)NCS + (vii)NCS =",
        totalSen: "Total(SEN): (vi)SEN + (vii)SEN =",
        totalNac: "Total(NAC): (vi)NAC + (vii)NAC =",
        activitiesCommunityIIBix: "(ix) Total no. of non-eligible",
        activitiesCommunityIIBixBefore: "(ix) Total no. of non-eligible",
        activitiesCommunityIIBixAfter: " students(must pay full fee):",
        activitiesCommunityIIBTotal: "Total no. of students (viii) + (ix) =",
        activitiesCommunityIIBx: "Total no. of students (viii) + (ix) =",
        totalX: "Total(Count by heads): (viii)Total + (ix)Total =",
        totalXNcs: "Total(NCS): (viii)NCS + (ix))NCS =",
        totalXSen: "Total(SEN): (viii)SEN + (ix))SEN =",
        totalXNac: "Total(NAC): (viii)NAC + (ix))NAC =",
        financialSummaryIII: `(III) Financial Summary of the whole project (up to {{upToDateEn}})`,
        summaryE: "(E) Administration cost",
        summaryF: "(F) Project coordination cost",
        summaryG:
            "(G) Administration and project co-ordination cost subsidised by NGO",
        summaryH: "(H) Total project expenditure = (D1) + (D2) + (E) + (F)",
        summaryI: "(I) Amount of approved grant",
        summaryJ: "(J) Interest earned (if any)",
        summaryK:
            "(K) Total project income = (B1) + (B2) + (C1) + (C2) + (G) + (I) + (J)",
        summaryBalance: "Balance = (K) – (H)",
        summaryTips:
            "Please fill in accordance with <b>item 5 of part J of the application form</b>, i.e. the total amount of grant approved to your organisation before the due date of this progress report",
        effectiveness: "B. Project Effectiveness",
        effectivenessTips:
            "In general, how would you rate the achievements of the activities conducted / in progress to the benefitted eligible students?",
        learningEffectiveness: "Learning Effectiveness",
        learningMotivation: "a) Students' motivation for learning",
        effectivenessOption: {
            1: "Significant Improved",
            2: "Moderate Improved",
            3: "Slight Improved",
            4: "No Change",
            5: "Declining",
            6: "Not Applicable",
        },
        studySkills: "b) Students' study skills",
        academicAchievement: "c) Students' academic achievement",
        outsideExperience: "d) Students' learning experience outside classroom",
        overallEffectivenes:
            "e) Your overall view on students' learning effectivenes",
        development: "Personal and Social Development",
        selfEsteem: "f) Students' self-esteem",
        selfManagement: "g) Students' self-management skills",
        socialSkills: "h) Students' social skills",
        interpersonalSkills: "i) Students' interpersonal skills",
        cooperativenessSkill: "j) Students' cooperativeness skill with others",
        attitudesToward: "k) Students' attitudes toward schooling",
        outlookOnLife: "l) Students' outlook on life",
        overallView:
            "m) Your overall view on students' personal and social development",
        communityInvolvement: "Community Involvement",
        participation:
            "n) Situation on students' participation in extra-curricular and voluntary activities",
        belongingSense: "o) Students' sense of belonging",

        understanding: "p) Students' understanding on the community",
        overallView2: "q) Your overall view on students' community involvement",
        comments: "C. Comments on the project conducted",
        difficulties:
            "Have you encountered any of the following problems/difficulties when implementing the project? \n(You may tick more than one box):",
        difficultiesOption: {
            manpower: "Insufficient manpower to conduct the activities",
            eligibleStudents:
                "Collaborating schools unable to provide sufficient no. of eligible students(i.e. students receiving CSSA, full grant under SFA Schemes)",
            eligibleUnwilling:
                "Eligible students unwilling to join the programmes",
            collaborating:
                "Collaborating schools unable to provide appropriate support",
            unableEmploy:
                "Unable to employ suitable tutors to conduct activities",
            funds: "Complicated requirements for handling funds disbursed by EDB",
            reportComplicated:
                "The reporting requirements too complicated and time-consuming",
            other: "Other suggestions",
        },
        specify: "Please specify",
        specifyReason: "Please specify the reasons",
        otherMsg: "suggestions",
        suggestions:
            "If you have other suggestions (e.g. mode of collaboration, nature of activities, etc.) on the project, please specify below",
        incomeExpenditure: `Statement of Activity Income & Expenditure (up to {{upToDate}})`,
        projectInformation: "Basic information of the project",
        actualEligibleNo: "Actual no. of eligible students participated",
        actualNoneligibleNo: "Actual no. of non-eligible students participated",
        incomeItems: "Income Items",
        grantAmount: "Amount of grant approved for this activity",
        nonEligibleFees: "Fees collected from non-eligible students",
        others: "Others",
        othersIncome: "Others",
        otherSpecify: "Please specify",
        othersExpenditure: "Others",
        totalA: "Total Income(A)",
        subsidyB: "Subsidy by NGO(B)",
        expenditureItems: "Expenditure Items",
        activityGroupsTitle: "Activities that have been carried out",
        classroom: "Classroom",
        totalGroups: "Total groups",
        sessions: "Sessions",
        hr: "Hr(s)",
        activity: "Activity",
        activityGroups: "Each group (times)",
        tutorFee: "Tutor fee",
        halfDay: "Half day",
        fullDay: "Full day",
        tutorsNo: "No. of tutor(s)",
        hourlySalary: "Hourly salary",
        otherStaffNo: "No. of other staff",
        socialWorkersNo: "No. of social worker(s)",
        tutorTotal: "Total expenditure of tutors",
        socialWorkerTotal: "Total expenditure of social workers",
        othersTotal: "Total expenditure of others",
        material: "Material",
        campAdmissionFee: "Camp / Admission fee",
        studentsMeal: "Students' meal",
        transportationFee: "Activity transportation fee",
        volunteersNo: "No. of volunteers",
        volunteersAllowance: "Volunteers allowance",
        totalC: "Total Expenditure(C)",
        balance: "Balance(A+B-C)",
        fullOrHalf: "Half day or full day",
        fullOrHalfOption: {
            half: "Half day",
            full: "Full day",
        },
        incomeExpenditureChecked:
            "I have already checked all the information provided above and verified that all expenditure receipts are certified true and correct. I also confirm that the above approved activity is *in progress or completed",
        costA: "Approved Grant for Administration Cost(A)",
        AdministExpenses: "Administration Expenses",
        transportationFees: "Staff transportation fees",
        photoCopy: "Photo-copying",
        stationery: "Stationery",
        postage: "Postage",
        totalB: "Total Expenditure for Administration(B)",
        costC: "Administration Cost Subsidised by NGO (if any)(C)",
        balanceD: "Balance(D)=(A+C-B)",
        costE: "Approved Grant for Project Coordination Cost(E)",
        costF: "Project Coordination Cost(F)",
        costG: "Project Coordination Cost Subsidised by NGO (if any)(G)",
        balanceH: "Balance(H)=(E+G-F)",
        costI: "(I) Amount of approved grant",
        costJ: "(J) Interest earned (if any)",
        statementCost: `Statement of Administration & Project Coordination Cost (up to {{upToDate}})`,
        ngoType:
            "Name of NGO/Name of Department/Name of Subsidiary Organisation",
        ngoName: "Name of {{ngoType}}",
        ngoHeadType:
            "Head of NGO/Department/Subsidiary Organisation/Project Coordinator",
        ngoHeadTypeName: "Head of {{ngoType}}/Project Coordinator",
        ngoHeadName: "Name",
        ngoHeadPost: "Post",
        ngoHead: "Head of {{ngoType}}",
        checkedFlag:
            "I have already checked all the information provided above and verified that all expenditure receipts are certified true and correct.",
        Notes: "Notes",
        statementCheck:
            "I have read, understood and agreed to the above terms and conditions",
    },
    select: {
        ngoOption: {
            ngo: "NGO",
            department: "Department",
            subsidiaryOrganisation: "Subsidiary Organisation",
        },
        ngoHeadOption: {
            ngoHead: "Head of NGO/Department/Subsidiary Organisation",
            projectCoordinator: "Project Coordinator",
        },
    },
    comma: ", ",
    semicolon: ";",
    errorMsg: {
        "E-0120": "One of the first 3 items is required",
        "E-0122": "One of the two parts is required",
        "E-0123": "{{fildName}} not repeatable",
        "E-0125": "this field must have at least 1 items",
        "E-0126": "One of the first three fields must be filled in",
        "E-0127": "This field must be less than or equal to the {{fildName}}",
        "E-0128": "Please do not select duplicate school type",
    },
};
export default Form005EN;
